<template>
    <el-radio-group
        class="base-radio-group"
        data-testid="input-radio-group"
        :size="size"
        v-bind="attrs"
        v-on="listeners"
    >
        <slot />
    </el-radio-group>
</template>

<script setup lang="ts">
import { RadioGroup as ElRadioGroup } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const listeners = useListeners()
const attrs = useAttrs()

withDefaults(
    defineProps<{
        size?: 'medium' | 'small' | 'mini'
    }>(),
    {
        size: 'small'
    }
)
</script>

<style lang="scss">
    .el-radio-group.base-radio-group {
        @apply inline-flex;
    }
</style>
